<!-- 资金管理-商户列表 -->
<template>
  <div>
    <page :url="url"
          :form="form"
          @reset="reset"
          :sort-info="{ prop: 'createTimeL', order: 'descending' }">
      <template slot="tableSearch">
        <el-form-item :label="$t('text.status')">
          <el-select v-model="form.status"
                     :placeholder="$t('text.status')">
            <el-option :label="$t('option.all')"
                       value=""/>
            <el-option :label="$t('withdrawalStatus.00')"
                       value="00"/>
            <el-option :label="$t('withdrawalStatus.01')"
                       value="01"/>
            <el-option :label="$t('withdrawalStatus.02')"
                       value="02"/>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('text.date')">
          <el-date-picker v-model="timeDate"
                          type="daterange"
                          format="yyyy-MM-dd"
                          value-format="yyyyMMdd"
                          :range-separator="$t('text.to')"
                          :start-placeholder="$t('text.startDate')"
                          :end-placeholder="$t('text.endDate')"
                          @change="timeChange"/>
        </el-form-item>
      </template>

      <template slot="tableColumn">
        <el-table-column width="200"
                         prop="orderId"
                         :label="$t('text.orderNumber')"
                         align="center"/>
        <el-table-column prop="createTimeFormat"
                         :label="$t('text.creationTime')"
                         sortable
                         align="center"/>
        <el-table-column prop="status"
                         :label="$t('text.status')"
                         width="150px"
                         :formatter="$formatter.formatWithdrawStatus"
                         align="center">
          <template slot-scope="{ row }">
            <el-tag size="small"
                    :type="row.status === '00'
                         ? 'warning'
                         : row.status === '01'
                         ? 'success'
                         : 'danger'">
              {{ $formatter.formatWithdrawStatus(null, null, row.status, null) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="amount"
                         width="160px"
                         :label="$t('text.withdrawalAmount')"
                         :formatter="$formatter.FenToYuanToThousandth"
                         align="center"/>
        <el-table-column prop="paymentAccount"
                         :label="$t('text.disbursementAccount')"
                         align="center">
          <template slot-scope="{ row }">
            <div v-if="row.paymentAccount">{{ row.paymentAccount }}</div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column prop="collectAccount"
                         :label="$t('text.collectionAddress')"
                         align="center"/>
        <el-table-column width="200"
                         prop="remark"
                         :label="$t('text.applicationNote')"
                         align="center">
          <template slot-scope="{ row }">
            <div v-if="row.remark">
              <el-popover v-if="row.remark && row.remark.length > 12"
                          placement="top-start"
                          width="300"
                          trigger="hover"
                          :content="row.remark">
                <div slot="reference" class="remark">{{ row.remark }}</div>
              </el-popover>
              <div v-else>{{ row.remark }}</div>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column width="160"
                         prop="dealTimeFormat"
                         :label="$t('text.processingTime')"
                         align="center"/>
        <el-table-column width="200"
                         prop="approveRemark"
                         :label="$t('text.approvalRemark')"
                         align="center">
          <template slot-scope="{ row }">
            <div v-if="row.approveRemark">
              <el-popover v-if="row.approveRemark && row.approveRemark.length > 12"
                          placement="top-start"
                          width="300"
                          trigger="hover"
                          :content="row.approveRemark">
                <div slot="reference" class="remark">
                  {{ row.approveRemark }}
                </div>
              </el-popover>
              <div v-else>{{ row.approveRemark }}</div>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
      </template>
    </page>
  </div>
</template>
<script>
import Page from "@/components/Page.vue";

export default {
  components: {
    page: Page,
  },
  data() {
    return {
      url: "/depositWithdraw/selectList?type=01",
      timeDate: [],
      form: {
        startDate: "",
        endDate: "",
        status: "",
        sortType: "00",
      },
    };
  },
  methods: {
    timeChange(e) {
      console.log(this.timeDate);
      if (e) {
        this.form.startDate = e[0];
        this.form.endDate = e[1];
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
    },
    reset() {
      this.timeDate = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.remark {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
</style>